export default __webpack_public_path__ + "static/media/Elder Wand - Img - Final (2)_05.f76d0fa8.jpg";